import i18n from '@/utils/i18n';
import RegInput from './reg/index';
export { RegInput };
import Clickoutside from 'element-ui/src/utils/clickoutside';
export { Clickoutside };
import { searchAuthInPermission } from '@/utils/index';
/*
按钮权限判断*/
export const checkButtons = {
  inserted(el, binding, vnode) {
    const { value } = binding;
    if (value) {
      if (!searchAuthInPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(
        `${i18n.t(
          'directiveIndex.needToConfigurePermissionResources!LikeThis'
        )}v-permission="add/btn"`
      );
    }
  },
};
// 防止页面重复点击
export const noMoreClick = {
  inserted(el) {
    el.addEventListener('click', (e) => {
      el.classList.add('is-disabled');
      el.disabled = true;
      setTimeout(() => {
        el.disabled = false;
        el.classList.remove('is-disabled');
      }, 3000);
    });
  },
};

// 防止页面重复点击，无class
export const noMoreClassClick = {
  inserted(el, binding) {
    el.addEventListener('click', (e) => {
      el.disabled = true;
      setTimeout(() => {
        el.disabled = false;
      }, binding.value || 2000);
    });
  },
};
// 动态计算表格的高度
let debounce = null;
export const calcTableHeight = {
  inserted(el) {
    setTimeout(() => {
      const classList = el.classList;
      classList.add('calc-table');
    }, 0);
  },
  componentUpdated(el, binding) {
    const { listLoading, outLength, fix = 0 } = binding.value;
    if (listLoading) {
      return;
    }
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => {
      // 初始化
      const classList = el.classList;
      if (classList.contains('scroll-wrapper')) {
        classList.remove('scroll-wrapper');
      }
      if (classList.contains('fill-screen')) {
        classList.remove('fill-screen');
      }
      el.style.height = 'auto';
      const windowClientHeight = window.document.body.clientHeight;
      const tableOffsetTop = el.offsetTop;
      const tableOffsetHeight = el.offsetHeight;
      let paddingBottom = 60 + fix;
      if (outLength) {
        paddingBottom += 70;
      }
      if (windowClientHeight > tableOffsetTop + tableOffsetHeight + paddingBottom) {
        el.style.height = `${windowClientHeight - tableOffsetTop - paddingBottom}px`;
        classList.add('fill-screen');
      } else {
        classList.add('scroll-wrapper');
      }
    }, 50);
  },
};
// 价格输入限定指令
export const priceInput = {
  inserted(el, binding, VNode) {
    var input = getInputElement(el);
    const vNodeInstance = VNode.componentInstance; // 获取当前元素的vue实例
    const { limitlength = 0 } = vNodeInstance.$attrs; // 获取价格输入框，限制输入的整数位个数
    const isSetDefault = vNodeInstance.$attrs.hasOwnProperty('is-set-default');
    var reg = null;
    if (binding.arg === 'num') {
      reg = /^\d*/g;
    } else if (binding.arg === 'minus') {
      reg = /^(-?)\d*/g;
    } else if (binding.arg === 'onlyMinusPoint') {
      reg = /^-\d*(\.?\d{0,2})/g;
    } else if (binding.arg === 'minusPoint') {
      reg = /^(-?)\d*(\.?\d{0,2})/g;
    } else if (binding.arg === 'price') {
      reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}/g;
    }
    el.addEventListener('input', function () {
      const inputValue =
        input.value.includes('.') || input.value.includes('-')
          ? input.value
          : input.value.startsWith('0')
          ? +input.value + ''
          : input.value;
      if (binding.arg === 'blank') {
        input.value = inputValue.replace(reg, '');
      } else if (['price', 'minusPoint', 'onlyMinusPoint'].includes(binding.arg)) {
        if (inputValue && inputValue.length > limitlength) {
          input.value = checkPriceNumLimit(inputValue.match(reg, ''), limitlength);
        } else {
          const matchValue = inputValue.match(reg, '') || '';
          input.value = isSetDefault ? (matchValue.toString() && matchValue) || 0 : matchValue;
        }
      } else {
        input.value = inputValue.match(reg, '');
      }
      vNodeInstance.$emit('input', input.value);
    });
  },
};
/*
 * 价格输入整数位输入限制
 * */
function checkPriceNumLimit(price, limitlength) {
  price = (price && price.toString()) || '';
  const tempArr = price.split('.');
  tempArr[0] = tempArr[0].substring(0, limitlength);
  return [
    tempArr[1]
      ? `${tempArr[0]}.${tempArr[1]}`
      : price.includes('.')
      ? `${tempArr[0]}.`
      : tempArr[0],
  ];
}
/*
 * 获取input元素
 * */
function getInputElement(el) {
  let input = null;
  if (el.getElementsByTagName('input')[0]) {
    input = el.getElementsByTagName('input')[0];
  } else if (el.getElementsByTagName('textarea')[0]) {
    input = el.getElementsByTagName('textarea')[0];
  } else {
    input = el;
  }
  return input;
}
